import { componentSizeMap } from '@lit-element/constants'

import type { ComponentSize } from '@lit-element/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
